// import convert from "heic-convert";

export const uuid = () => {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
};

export const hasText = (text, find) => {
  if (text && text.trim()) {
    return text.indexOf(find) > -1;
  }

  return false;
};

export const findInfoProduct = (configProducts, item) => {
  const withCode =
    (configProducts || []).length > 0 &&
    (configProducts || []).find((row) => row.value);
  const withoutCode =
    (configProducts || []).length > 0 &&
    (configProducts || []).find((row) => !row.value || row.value === '');
  if (
    (withCode.value || '')
      .toLowerCase()
      .includes(item.code_product.toString().toLowerCase() || '')
  ) {
    return withCode;
  }
  return withoutCode;
};

export const existValue = (val) => val || {};

export const blobToBase64 = (file) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
    };
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
};

// export const convertHEICtoJPEG = async (files) => {
//   const newFiles = [];
//   for (let value of files) {
//     const arrayName = value.file.name.split(".");
//     let current = value;
//     if (arrayName.pop() === "heic") {
//       let fileConvert = await convert({
//         buffer: value.file.buffer,
//         format: "JPEG",
//         quality: 0.5,
//       });
//       fileConvert = new Blob([fileConvert]);
//       current.file.buffer = "";
//       current.file.name = `${arrayName[0]}.jpeg`;
//       current.file.type = "image/jpeg";
//       current.file.content = await blobToBase64(fileConvert);
//     }
//     newFiles.push(current);
//   }
//   return newFiles;
// };
